import { IsMobile } from "utils/is-mobile";

import { Grid } from "@material-ui/core";

import InputText from "components/_refactor/text/input";
import FromToDateField from "components/_refactor/fields/from-to-date";

export default function Filters({ isLoading, filters, setFilters }) {
  const isMobile = IsMobile();

  const handleChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <>
      <Grid item xs={12} md={6} lg={4}>
        <InputText
          placeholder="Nome da vitrine"
          onChange={(e) => handleChange("vitrineName", e.target.value)}
          disabled={isLoading}
          required={false}
          value={filters.vitrineName || ""}
          className="form-control"
          style={{ width: "100%" }}
          label="Vitrine"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <InputText
          placeholder="Nome do cliente"
          onChange={(e) => handleChange("clienteName", e.target.value)}
          disabled={isLoading}
          required={false}
          value={filters.clienteName || ""}
          className="form-control"
          style={{ width: "100%" }}
          label="Cliente"
        />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <InputText
          placeholder="CNPJ"
          onChange={(e) => handleChange("cnpj", e.target.value)}
          disabled={isLoading}
          required={false}
          value={filters.cnpj || ""}
          className="form-control"
          style={{ width: "100%" }}
          label="CNPJ"
        />
      </Grid>
      <Grid item xs={12} md={12} lg={8}>
        <FromToDateField
          label="Data do pré-pedido"
          disablePrefixLabels={true}
          initialDate={filters.dataPrePedidoInicio}
          finalDate={filters.dataPrePedidoFim}
          disabled={isLoading}
          setInitialDate={(value) => handleChange("dataPrePedidoInicio", value)}
          setFinalDate={(value) => handleChange("dataPrePedidoFim", value)}
          isMobile={isMobile}
          pattern="br"
        />
      </Grid>
    </>
  );
}
